// session.service.ts
import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, merge, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private activitySub: Subscription | null = null;

  constructor(private http: HttpClient, private zone: NgZone, private httpService: HttpService) {}

  startSendingKeepAlive() {
    if (this.activitySub) return;

    const events$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'click'),
      fromEvent(document, 'keypress'),
      fromEvent(document, 'scroll')
    ).pipe(throttleTime(5000)); // max one call every 5s

    this.zone.runOutsideAngular(() => {
      this.activitySub = events$.subscribe(() => {
        this.http.get(this.httpService.getUrl()+'/protected').subscribe({
          next: () => console.log('Protect ping sent'),
          error: err => console.error('Protect ping failed', err)
        });
      });
    });
  }

  stopSendingKeepAlive() {
    this.activitySub.unsubscribe();
    this.activitySub = null;
  }
}